import React from 'react';
import { LeafDivider, Section } from './Shared';
export const CostComparison = () => {
  const costs = [{
    without: 'Indicar sin ficha técnica validada',
    cost: 'Inseguridad clínica que el paciente percibe'
  }, {
    without: 'Sin semáforo de seguridad por planta',
    cost: 'Riesgo real de indicar algo contraindicado'
  }, {
    without: 'Sin tabla de interacciones',
    cost: 'Paciente medicado en riesgo sin saberlo'
  }, {
    without: 'Sin protocolo por sistema',
    cost: 'Cada sesión construida desde cero, sin estructura'
  }, {
    without: 'Sin recetario de fórmulas',
    cost: 'Combinaciones improvisadas sin respaldo'
  }, {
    without: 'Sin dosificación pediátrica',
    cost: 'No sabes cómo ajustar para niños o adultos mayores'
  }, {
    without: 'Sin criterios de derivación',
    cost: 'No sabes cuándo la fitoterapia no es suficiente'
  }, {
    without: 'Sin ficha de consultorio',
    cost: 'Cada consulta sin registro ni continuidad real'
  }, {
    without: 'Sin guía de proveedores',
    cost: 'Materia prima de calidad desconocida'
  }, {
    without: 'Sin espagiria vegetal',
    cost: 'Pierdes pacientes que buscan preparaciones avanzadas'
  }, {
    without: 'Sin el sistema',
    cost: 'El mismo ciclo de incertidumbre, la próxima semana'
  }];
  return <Section data-id="element-17" data-mp="2gb6f0vqpkiv8">
      <div className="text-center mb-12" data-id="element-18" data-mp="2gawlwzad9vlb">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[24px] text-brand-purpleDark" data-id="element-19" data-mp="2gdsncxlfb2ei">
          <span className="mr-3" data-id="element-20" data-mp="26d9x9l39mpo5">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-21" data-mp="1smdfyqeshuwe">
        <div className="hidden md:block" data-id="element-22" data-mp="1sneq8snzedd2">
          <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-23" data-mp="1skaixmf7z1i6">
            <div className="font-serif font-bold text-lg text-brand-purple" data-id="element-24" data-mp="1xlq196q0itwv">
              Sin el Megapack Saberes Ancestrales
            </div>
            <div className="font-serif font-bold text-lg text-brand-burgundy" data-id="element-25" data-mp="1nn0rk189sfrp">
              Costo real
            </div>
          </div>
          <div className="space-y-3" data-id="element-26" data-mp="14jgts77d0paz">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 glass-panel p-5 rounded-xl items-center border-brand-burgundy/10 bg-white/70" data-id="element-27" data-mp="zrp0howtk5h5" data-mpi={i}>
                <div className="text-sm font-medium text-brand-text pr-4" data-id="element-28" data-mp="utdtrn1tmb35">
                  {row.without}
                </div>
                <div className="text-sm text-brand-burgundy/90 font-medium" data-id="element-29" data-mp="preou8qfn643">
                  {row.cost}
                </div>
              </div>)}
          </div>
        </div>

        <div className="md:hidden space-y-4" data-id="element-30" data-mp="1ijhthjbw1qov">
          {costs.map((row, i) => <div key={i} className="glass-panel p-4 rounded-xl border-brand-burgundy/10 bg-white/70 space-y-2" data-id="element-31" data-mp="1dikcha2m72oy" data-mpi={i}>
              <p className="text-sm font-medium text-brand-text" data-id="element-32" data-mp="18iz5ccdajo15">
                {row.without}
              </p>
              <div className="flex items-start space-x-2 text-brand-burgundy/90 font-medium" data-id="element-33" data-mp="24q5rjpot7lw">
                <span className="text-brand-burgundy shrink-0" data-id="element-34" data-mp="3t9gg61bi79kn">→</span>
                <span className="text-sm" data-id="element-35" data-mp="28spaxso6zihk">{row.cost}</span>
              </div>
            </div>)}
        </div>
      </div>

      <LeafDivider className="mt-14" data-id="element-36" data-mp="2dsbpc5frb4ry" />

      <div className="text-center" data-id="element-37" data-mp="2dp7begchouo3">
        <p className="text-xl md:text-2xl font-display italic font-[600] text-brand-purpleDark" data-id="element-38" data-mp="2ipv2t34mrdiu">
          "El terapeuta que tiene un sistema aplica con confianza. El que aplica
          con confianza genera resultados. El que genera resultados, crece." 🌿
        </p>
      </div>
    </Section>;
};